import React from "react";
import PropTypes from "prop-types";
import { Route, Routes } from "react-router-dom";
import OwnerContract from "./Owner";
import ContractorContract from "./Contractor";

const Contract = (props) => {
  return (
    <Routes>
      <Route path="owner" element={<OwnerContract />} />
      <Route path="contractor" element={<ContractorContract />} />
    </Routes>
  );
};

Contract.propTypes = {};

export default Contract;
